var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4259 20.4706L17.5362 15.7774C18.9535 14.144 19.6601 12.049 19.5093 9.92813C19.3585 7.80726 18.3617 5.82387 16.7264 4.39054C15.0911 2.95721 12.9431 2.1843 10.7293 2.2326C8.5155 2.2809 6.40631 3.14669 4.84051 4.64986C3.27471 6.15303 2.37285 8.17785 2.32254 10.3031C2.27222 12.4284 3.07733 14.4904 4.57039 16.0603C6.06344 17.6302 8.12947 18.5871 10.3387 18.7319C12.5479 18.8767 14.7303 18.1983 16.4317 16.8378L21.3204 21.5318C21.393 21.6015 21.4792 21.6568 21.574 21.6945C21.6688 21.7322 21.7705 21.7516 21.8731 21.7516C21.9758 21.7516 22.0774 21.7322 22.1723 21.6945C22.2671 21.6568 22.3533 21.6015 22.4259 21.5318C22.4985 21.4621 22.556 21.3794 22.5953 21.2884C22.6346 21.1973 22.6548 21.0997 22.6548 21.0012C22.6548 20.9026 22.6346 20.8051 22.5953 20.714C22.556 20.623 22.4985 20.5403 22.4259 20.4706ZM3.9044 10.5012C3.9044 9.16617 4.31677 7.86112 5.08938 6.75109C5.86198 5.64106 6.96011 4.7759 8.2449 4.265C9.5297 3.75411 10.9434 3.62044 12.3074 3.88089C13.6713 4.14134 14.9242 4.78422 15.9075 5.72822C16.8908 6.67222 17.5605 7.87496 17.8318 9.18433C18.1031 10.4937 17.9639 11.8509 17.4317 13.0843C16.8995 14.3177 15.9983 15.3719 14.842 16.1136C13.6857 16.8553 12.3263 17.2512 10.9356 17.2512C9.07148 17.2492 7.28425 16.5374 5.96609 15.272C4.64792 14.0065 3.90647 12.2908 3.9044 10.5012Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.59f26cf2f792590d9f66ecf71c4d689a.svg";
export { ForwardRef as ReactComponent };